import { ReactElement } from 'react';
import { HeapEvent } from 'config';

import { useCart } from 'contexts/Cart';

import { Component as WarningIcon } from 'icons/icon-circle--warning.svg';
import Modal from 'components/shared/Modal';

import { round, toCurrency } from '../../../utils/numbers';

type Props = {
  onClose: () => void,
  onDiscard: () => void,
  viewRecipeLink?: string,
};

function SaveOrDiscardModal({
  onClose,
  onDiscard,
  viewRecipeLink,
}: Props): ReactElement {
  const { cart } = useCart();
  const { subtotalPrice } = cart;
  const { minimum_base_price: minPrice } = cart.validations;
  const remainingValue = toCurrency(round(minPrice - subtotalPrice));

  return (
    <Modal
      show
      onClose={onClose}
      className="c-save-or-discard-modal"
      header={(
        <Modal.Header className="c-heading--brand-7" center={false}>
          <WarningIcon height="20" width="20" />
          You are below the order minimum for delivery
        </Modal.Header>
      )}
      body={(
        <div className="row">
          <div className="col-xs-12 col-12">
            { `Add ${remainingValue} to complete your order` }
          </div>
        </div>
      )}
      footer={(
        <>
          <div className="c-unsaved-cart-secondary-actions">
            {viewRecipeLink ? (
              <a
                type="button"
                className="c-button c-button--primary-link"
                href={`${viewRecipeLink}&canModify=false`}
              >
                Discard Changes & View Recipe
              </a>
            ) : (
              <button
                type="button"
                className={[
                  'c-button c-button--primary-link',
                  HeapEvent.UNSAVED_DISCARD_CHANGES,
                ].join(' ')}
                onClick={onDiscard}
              >
                Discard Changes
              </button>
            )}
          </div>

          <button
            type="button"
            className={[
              'c-button c-button--primary',
              HeapEvent.UNSAVED_CONTINUE_EDITING,
            ].join(' ')}
            onClick={onClose}
          >
            Edit Order
          </button>
        </>
      )}
    />
  );
}

export default SaveOrDiscardModal;
